import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'theme/index.css';
import '@zawarski/eti-ui/styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
